var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"pa-4",attrs:{"flat":""}},[_c('h1',[_vm._v(_vm._s(_vm.$t('users.title')))]),_c('br'),_c('custom-table',{attrs:{"title":"users.title","icon":"mdi-account-multiple","headers":[{
        text: _vm.$t('users.name'),
        align: 'left',
        sortable: false,
        value: 'ident',
      },
      { text: _vm.$t('users.email'), value: 'email' } ],"data":_vm.data,"count":_vm.count,"loading":_vm.loading,"onAdd":_vm.handleAdd,"onSearch":_vm.handleChangeSearch}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }